<template lang="pug">
  .columns
    .column.is-12
      .columns
        .column.is-12(v-html="getTitle()")
      .columns.has-text-left
        .column.is-12
          .columns
            .column.is-6
              b Origen:&nbsp
              | {{ isNaN(salida.origen) ?  salida.origen : `${salida.origen_ubicacion} - ${salida.origen_nombre}`}}
            .column.is-6
              b Destino:&nbsp
              | {{ salida.ubicacion ? salida.ubicacion.nombre : `${salida.destino_ubicacion} - ${salida.destino_nombre }` }}
          //- .columns
          //-   .column(v-html="getArea()")
          .columns
            .column.is-12
              b Entrega:&nbsp
              | {{ salida.entrega }}
          .columns(v-show="salida.isSalida")
            .column.is-12
              b Tralslada:&nbsp
              | {{ salida.traslada }}
          .columns
            .column.is-12
              b Recibe:&nbsp
              | {{ salida.recibe }}
          //- .columns
          //-   .column.is-12(v-html="getHash()")
</template>

<script>
    export default {
    name: 'CardSalidaCons',
    props: {
      salida: {
        type: Object,
        default: () => {}
      },
      items: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
      }
    },
    methods: {
      getTitle() {
        let htmlStr = ''
        switch (this.salida.estado) {
          case 0:
            if (this.salida.isSalida) {
              htmlStr = `<b class="is-size-6">Firmar Entrega<br/>Salida ${this.salida.id_salida}</b>`
            } else {
              htmlStr = `<b class="is-size-6">Firmar Entrega<br/>Asignación ${this.salida.id_asignacion}</b>`
            }
            
            break
          case 1:
            if (this.salida.isSalida) {
              htmlStr = `<b class="is-size-6">Firmar Entrega<br/>Salida ${this.salida.id_salida}</b>`
            } else {
              htmlStr = `<b class="is-size-6">Firmar Entrega<br/>Asignación ${this.salida.id_asignacion}</b>`
            }
            break
          case 2:
            if (this.salida.isSalida) {
              htmlStr = `<b class="is-size-6">Firmar Traslado<br/>Salida ${this.salida.id_salida}</b>`
            } else {
              htmlStr = `<b class="is-size-6">Firmar Recepción<br/>Asignación ${this.salida.id_asignacion}</b>`
            }
            break
          case 3:
            if (this.salida.isSalida) {
              htmlStr = `<b class="is-size-6">Firmar Recepción<br/>Salida ${this.salida.id_salida}</b>`
            }
            break
        
          default:
            htmlStr = `${this.salida.id}`
            break
        }
        
        return htmlStr
      },
    },
    created () {
      
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/CardSalidaCons.vue